export default "__VITE_ASSET__DnWW0rIO__"